module.exports = __webpack_public_path__ + "static/media/krx-tutorial-03.d52c34bc.jpg";